<template>
  <nav class="navbar">
    <div class="nav-links">
      <router-link v-for="item in navItems" :key="item.path" :to="item.path">
        {{ item.label }}
      </router-link>
    </div>
    <div class="lang-pill">
      <button
        v-for="option in languages"
        :key="option"
        type="button"
        :class="['lang-chip', { active: option === lang }]"
        @click="setLang(option)"
      >
        {{ option.toUpperCase() }}
      </button>
    </div>
  </nav>
  <main>
    <router-view></router-view>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { getMainNavItems } from "./shared/siteNavigation";
import { useSiteLanguage } from "./store/siteLanguage";

const { lang, languages, setLang } = useSiteLanguage();
const navItems = computed(() => getMainNavItems(lang.value));
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.navbar{
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  background-color:azure;
  width: 98vw;
  border:1px solid black;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-links{
  display:flex;
  align-items:center;
  flex-wrap:wrap;
}

.navbar a{
  color:black;
  margin: 0 15px;
  text-decoration: none;
}

.navbar a:hover{
  font-weight: bold;
  color:black;
  text-shadow: 0 4px 8px rgba(0,0,0,0.3);
  transform:translate(2px);
}

.lang-pill {
  display: inline-flex;
  gap: 6px;
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
}

.lang-chip {
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: #2c3e50;
  padding: 8px 12px;
  cursor: pointer;
}

.lang-chip.active {
  background: #2c3e50;
  color: white;
}

@media (max-width: 760px) {
  .navbar {
    flex-direction: column;
    align-items: stretch;
  }

  .lang-pill {
    align-self: flex-start;
  }
}


</style>
